import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import components
import MentorDashboard from '../components/mentors/MentorDashboard';
import SessionManagement from '../components/mentors/SessionManagement';
import SessionCreation from '../components/mentors/SessionCreation';
import MentorshipTracking from '../components/mentors/MentorshipTracking';
import MaterialManagement from '../components/mentors/MaterialManagement';
import MentorProfile from '../components/mentors/MentorProfile';
import MentorSettings from '../components/mentors/MentorSettings';
import MessageCenter from '../components/mentors/MessageCenter';
import StudentList from '../components/mentors/StudentList';
import NotFound from '../pages/public/NotFound';

/**
 * Nested routes configuration for the mentor panel
 */
const MentorRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MentorDashboard />} />
      <Route path="/dashboard" element={<Navigate to="/mentor" replace />} />
      <Route path="/sessions" element={<SessionManagement />} />
      <Route path="/sessions/new" element={<SessionCreation />} />
      <Route path="/tracking" element={<MentorshipTracking />} />
      <Route path="/materials" element={<MaterialManagement />} />
      <Route path="/profile" element={<MentorProfile />} />
      <Route path="/settings" element={<MentorSettings />} />
      <Route path="/messages" element={<MessageCenter />} />
      <Route path="/students" element={<StudentList />} />
      {/* Add any other mentor-specific routes here */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default MentorRoutes; 